import React from 'react';
import { Zap, Download, Upload } from 'lucide-react';

const Tile = ({ icon: Icon, label, value, unit, color, footer }) => (
  <div style={{
    flex: '1 1 0', minWidth: 90, background: `${color}12`, border: `1px solid ${color}24`,
    borderRadius: 14, padding: '12px 10px', textAlign: 'center',
  }}>
    <Icon size={16} color={color} style={{ marginBottom: 6 }} />
    <div style={{ fontSize: '1.15rem', fontWeight: 800, color: 'var(--c-111827)', lineHeight: 1 }}>
      {value != null ? value : '—'}
      {value != null && <span style={{ fontSize: '.65rem', fontWeight: 600, color: 'var(--text-muted)', marginLeft: 3 }}>{unit}</span>}
    </div>
    <div style={{ fontSize: '.68rem', fontWeight: 600, color: 'var(--text-muted)', marginTop: 4 }}>{label}</div>
    {footer}
  </div>
);

// Small "+Xms under download / +Yms under upload" row — bufferbloat, i.e. how much ping degrades
// once the link is actually saturated, same thing Ookla's small ↓/↑ numbers under its main ping
// figure show. Omitted entirely until both increases are in (keeps the tile from jumping around
// mid-test).
const PingLoadFooter = ({ downloadPingIncrease, uploadPingIncrease }) => {
  if (downloadPingIncrease == null && uploadPingIncrease == null) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 4, fontSize: '.62rem', fontWeight: 700, color: 'var(--text-muted)' }}>
      {downloadPingIncrease != null && <span>↓ +{downloadPingIncrease}ms</span>}
      {uploadPingIncrease != null && <span>↑ +{uploadPingIncrease}ms</span>}
    </div>
  );
};

// Ping/Download/Upload result row — shared between the portal and technical speed test pages.
export default function SpeedTestStats({ ping, downloadMbps, uploadMbps, downloadPingIncrease, uploadPingIncrease }) {
  return (
    <div style={{ display: 'flex', gap: 10, width: '100%' }}>
      <Tile
        icon={Zap} label="Ping" value={ping != null ? ping : null} unit="ms" color="#f59e0b"
        footer={<PingLoadFooter downloadPingIncrease={downloadPingIncrease} uploadPingIncrease={uploadPingIncrease} />}
      />
      <Tile icon={Download} label="Download" value={downloadMbps != null ? downloadMbps.toFixed(1) : null} unit="Mbps" color="#2563eb" />
      <Tile icon={Upload} label="Upload" value={uploadMbps != null ? uploadMbps.toFixed(1) : null} unit="Mbps" color="#059669" />
    </div>
  );
}
